// extracted by css-extract-rspack-plugin
export default {"ContextMenu":"src-wab-client-components-ContextMenu-module__ContextMenu-xys4yY","contextMenu":"src-wab-client-components-ContextMenu-module__ContextMenu-xys4yY"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"ContextMenu\":\"src-wab-client-components-ContextMenu-module__ContextMenu-xys4yY\",\"contextMenu\":\"src-wab-client-components-ContextMenu-module__ContextMenu-xys4yY\"}";
        // 1793541991312
        var cssReload = require("../../../../node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  